import { useSelector } from 'react-redux';
import { Progress, Tooltip, Image } from '@chakra-ui/react';
import styles from '../styles';
import { Card, CardBody } from 'components/v4/Card';
import CardDetails from './CardDetails';
import { useServicesDashboard } from 'context/ServicesDashboardContext';
import { getStatusConfig } from './VendorCard/Vendor/helper';
import vendor from 'assets/images/vendor.png';
import {
    TPM,
    SBC,
    VENDOR_DEFINED,
    OPERATOR_CONNECT,
    OPERATOR_PLATFORM,
    sbcStates,
} from '../constants';
import { isEmpty } from 'lodash';

const IconPlatform = ({ service }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const serviceStatus = useServicesDashboard();
    const vendorStatus = getStatusConfig(service?.statusDisplay);

    const cardStatus = () => {
        switch (service?.serviceType) {
            case VENDOR_DEFINED:
                return vendorStatus;
            case OPERATOR_PLATFORM:
                return vendorStatus;
            case TPM:
                return { ...serviceStatus[OPERATOR_CONNECT] };
            case SBC:
                return {
                    ...CardDetails(service?.serviceType),
                    color: sbcStates(darkMode)[
                        service?.statusDisplay?.statusDisplayLevel
                    ],
                    statusLabel:
                        service?.statusDisplay?.statusDisplayDetail ||
                        'Unknown',
                };
            default:
                return serviceStatus[service?.serviceType];
        }
    };

    const serviceName = service?.name;
    const statusText = cardStatus()?.statusLabel;

    const tooltipLabel = `${serviceName}: ${statusText}`.trim();
    const vendorCardImage = isEmpty(service.displayImage)
        ? vendor
        : // eslint-disable-next-line no-undef
          process.env.NODE_ENV === 'development'
          ? import.meta.env.VITE_APP_IMAGE_BASE +
            '/images/' +
            service.displayImage
          : window.location.origin + '/images/' + service.displayImage;

    return (
        <Tooltip label={tooltipLabel} hasArrow openDelay={150}>
            <Card
                bg={darkMode ? 'dark.tcap' : null}
                height="40px"
                width="40px"
                sx={styles.iconCard}>
                <Progress
                    value={100}
                    sx={{ ...styles.verticalBar, width: '6px' }}
                    colorScheme={cardStatus()?.color}
                    hasStripe={cardStatus()?.animation}
                    isAnimated={cardStatus()?.animation}
                />
                <CardBody
                    alignItems="center"
                    justifyContent="center"
                    display="flex"
                    height="40px"
                    paddingLeft="14px"
                    padding="8px">
                    <Image
                        src={
                            service?.serviceType === VENDOR_DEFINED ||
                            service?.serviceType === OPERATOR_PLATFORM
                                ? vendorCardImage
                                : CardDetails(service?.serviceType)?.icon
                        }
                        sx={{ maxWidth: '20px' }}
                    />
                </CardBody>
            </Card>
        </Tooltip>
    );
};

export default IconPlatform;
